<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-if="!isLoading" class="search">
      <div class="container">
        <div class="row">
          <h1 class="mt-4">
            <span style="cursor: pointer">Categories >> </span
            >{{
              this.$route.params.parent_name === this.$route.params.name
                ? ""
                : `${this.$route.params.parent_name} >>`
            }}
            {{ this.$route.params.name }}
          </h1>
        </div>
        <div class="row">
          <div class="cards-display-grid mt-4">
            <products-card
              v-for="(product, index) in products"
              :key="index"
              :product="product"
              style="margin-right: 15px;"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/views/Loading";
import router from "../router";
import axios from "axios";
import ProductsCard from "../components/Utilities/Cards/Products.vue";

export default {
  components: {
    Loading,
    ProductsCard,
  },
  data() {
    return {
      products: [],
      word: "search here",
      isLoading: true,
    };
  },
  created() {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
    axios
      .get(
        `https://api.ardunic.com/v1/product/category/${this.$route.params.id}`
      )
      .then((res) => {
        this.products = res.data.data;
      });
  },
  methods: {
    search() {
      axios
        .get(`https://api.ardunic.com/v1/search?name=${this.word}`)
        .then((res) => {
          this.products = res.data.data.products;
        });
      router.push({ path: `/search/${this.word}` });
    },
    getLink(link) {
      if (link.startsWith("http")) return link;
      else return `https://${link}`;
    },
  },
};
</script>

<style scoped>
.search {
  margin-top: 90px;
}
.cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.btn {
  border-radius: 15px;
}

@media (max-width: 767px) {
  #search-cards-row {
    padding: 0px;
  }
  #list-col {
    max-width: 100%;
  }
}

.filters {
  list-style: none;
  text-align: center;
}
.filters .filter-iteam {
  /* background: #c1c2c5; */
  margin: 5px;
  width: 200px;
  border-radius: 15px;
  font-size: 1.2rem;
  color: white;
}

.grey {
  background: #c1c2c5;
}

.botn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  width: 400px;
  height: 60px;
  font-weight: bold;
}
.botn-blue {
  color: white;
  text-align: center;
  background: linear-gradient(to right, #f6893a, #fdbd5d);
}

.org {
  background: linear-gradient(right, #ff3fbb, #ff8891);
}

.blue {
  background: linear-gradient(to right, #05cefc, #5659ce);
}
.view-more {
  position: relative;
  top: -30px;
}

.filterBy {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}

#search {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
  font-size: 30px;
  color: black;
}
/* .filters {
  text-align: center;
  margin: 0 auto;
} */

.card-new {
  margin-bottom: 13px;
  border-radius: 10px;
  padding: 12px 12px;
  overflow: hidden;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.img-new {
  width: 100%;
}

.img-div {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  line-height: 0;
  width: 100%;
  overflow: hidden;
}

.card-img-new {
  max-height: 100%;
  max-width: 100%;
}

.title-new {
  height: auto;
  line-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.price-new {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-span {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  color: #333;
  vertical-align: middle;
  font-weight: 700;
}
</style>
